import React, { useState, useEffect } from "react";
import { Steps } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { updateLeadDetails } from "../../actionCreator/leadDetailsActionCreator";

const Stepsbar = () => {
  const dispatch = useDispatch();
  const [leadStatusList, setLeadStatusList] = useState([]);
  const [mapStatusData, setMapStatusData] = useState([]);
  const [current, setCurrent] = useState(0);
  const leadStatusListing = useSelector(
    (state) => state.leadListingReducer.leadStatusList,
  );
  const leadDetail = useSelector(
    (state) => state.LeadDetailsReducer.leadDetails,
  );

  const onChangeStatus = (value) => {
    setCurrent(value);
    let statusSequenceValue = value + 1;
    if (mapStatusData.has(statusSequenceValue)) {
      const statusObj = mapStatusData.get(statusSequenceValue);

      let payload = leadDetail;
      payload.status = statusObj.id;
      payload.stepsbar = true;

      dispatch(updateLeadDetails(payload, true));
    }
  };

  useEffect(() => {
    let currentSequence = 0;
    let mapStatusData = new Map([]);
    leadStatusListing.map((item) => {
      if (leadDetail?.status === item.id) {
        currentSequence = item.sequence;
      }
      mapStatusData.set(item.sequence, item);
    });
    setMapStatusData(mapStatusData);
    setCurrent(currentSequence);
  }, [leadDetail, leadStatusListing]);

  useEffect(() => {
    const statusItem = [];
    const currentSequence = current;
    leadStatusListing.map((item) => {
      let clstatus = "";
      if (currentSequence === item.sequence) {
        clstatus = "steps-active";
      } else if (item.sequence < currentSequence) {
        clstatus = "steps-done";
      } else if (currentSequence + 1 === item.sequence) {
        clstatus = "steps-pending";
      } else {
        clstatus = "steps-pending";
      }
      statusItem.push({
        className: clstatus,
        status: "wait",
        title: item.text,
      });
    });
    setLeadStatusList(statusItem);
  }, [current, leadStatusListing]);

  return (
    <div className="tw-mb-4 steps-wrapper tw-overflow-x-auto tw-w-full">
      <Steps
        type="navigation"
        responsive={false}
        current={current === 0 ? current : current - 1}
        onChange={onChangeStatus}
        items={leadStatusList}
        className="!tw-font-inter !tw-text-text-primary"
      />
    </div>
  );
};

export default Stepsbar;
